<template>
  <div id="defaultId1">
    <div class="pb20">
      <div
        class="flex_center_between_box"
        v-if="profitablitylist?.length > 0"
        style="align-items: start"
      >
        <gui_card
          id="ge6845"
          class="uc1096 content-left"
          label=""
          :isShowLabel="false"
          style="flex: 1; height: auto"
        >
          <div>
            <h2 class="operations-head-content">
              <span class="operations-head"
                >{{ $t("CreditOpinion.CreditAssessment") }}
                <i
                  class="iconfont icon-rili riliicon cur_pointer"
                  @click="createDialog = true"
                ></i>
              </span>
              <div
                v-if="parentTablelist.length > 0"
                class="ViewMore contclass flex_center"
                @click="scrollToTop('#Card')"
              >
                <span>{{
                  $t("CreditOpinion.CreditAssessmentfromtheRelatedCompanies")
                }}</span>
                <div class="Financial-icon-part">
                  <i
                    class="iconfont icon-gantanhao1 huanggantanhaoicon"
                    @click="createDialog = true"
                  ></i>
                  <div class="Financial-icon-box">
                    {{ $t("CreditOpinion.CreditAssessmentMessage1") }}
                    <br />
                    {{ $t("CreditOpinion.CreditAssessmentMessage2") }}
                  </div>
                </div>
              </div>
            </h2>
            <tableVue
              :profitablitylist="profitablitylist"
              :yearslist="yearslist1"
              :nodataYears="nodataYears1"
              :untia="untia"
              :createDialog="createDialog"
              @createDialogcheck="createDialogcheck"
            ></tableVue>
          </div>
        </gui_card>
        <gui_card
          id="ge6845"
          class="uc1096 content-right"
          label=""
          :isShowLabel="false"
          style="padding: 0px !important"
        >
          <div class="" style="position: relative">
            <div class="table">
              <div class="table_box">
                <span class="aaa">{{ $t("CreditOpinion.HighRisk") }}</span>
                <span class="bbb">{{ $t("CreditOpinion.Medium") }}</span>
                <span class="ccc">{{ $t("CreditOpinion.Moderate") }}</span>
                <span class="ddd">{{ $t("CreditOpinion.Average") }}</span>
                <span class="fff">{{ $t("CreditOpinion.LowerThanAvg") }}</span>
                <span class="ggg">{{ $t("CreditOpinion.LowRisk") }}</span>
                <span class="hhh"
                  >{{ $t("CreditOpinion.CreditOpinion") }}

                  <div
                    class="ViewMore contclass flex_center Financial-icon-part-right"
                  >
                    <div class="Financial-icon-part">
                      <i
                        class="iconfont icon-gantanhao1 huanggantanhaoicon"
                        @click="createDialog = true"
                      ></i>
                      <div>
                        <div class="Financial-icon-box Financial-icon-bocredit">
                          <div class="margin-bottom30">
                            <h3
                              class="Financial-icon-bocredit-title margin-bottom20"
                            >
                              {{ $t("CreditOpinion.LocalCreditRating") }}
                            </h3>
                            {{ $t("CreditOpinion.LocalCreditRatingDetail") }}
                          </div>
                          <div class="margin-bottom30">
                            <h3
                              class="Financial-icon-bocredit-title margin-bottom20"
                            >
                              {{ $t("CreditOpinion.CreditScore") }}
                            </h3>
                            {{ $t("CreditOpinion.CreditScoreDetail") }}
                          </div>
                          <div class="margin-bottom30">
                            <h3
                              class="Financial-icon-bocredit-title margin-bottom20"
                            >
                              {{ $t("CreditOpinion.PossibilityofDefault") }}
                            </h3>
                            {{ $t("CreditOpinion.PossibilityofDefaultDetail") }}
                          </div>
                          <div class="margin-bottom30">
                            <h3
                              class="Financial-icon-bocredit-title margin-bottom20"
                            >
                              {{ $t("CreditOpinion.SolvencyIndexSI") }}
                            </h3>
                            {{ $t("CreditOpinion.SolvencyIndexSIDetail") }}
                          </div>
                          <div class="table_X">
                            <el-table
                              :data="RatingData"
                              empty-text="No Data"
                              style="width: 100%"
                              class="uvnONjL uzrM6EH ukIKpaz"
                            >
                              <el-table-column
                                prop="ARating"
                                :label="$t('CreditOpinion.Rating')"
                                align="left"
                                show-overflow-tooltip
                              >
                              </el-table-column>
                              <el-table-column
                                prop="External"
                                :label="$t('CreditOpinion.ExternalRating')"
                                align="left"
                                show-overflow-tooltip
                              >
                              </el-table-column>
                              <el-table-column
                                prop="Default"
                                :label="$t('CreditOpinion.DefaultProbability')"
                                align="left"
                                width="300"
                                show-overflow-tooltip
                              >
                              </el-table-column>
                              <el-table-column
                                prop="Credit"
                                :label="$t('CreditOpinion.CreditScore')"
                                align="left"
                                show-overflow-tooltip
                              >
                              </el-table-column>
                              <el-table-column
                                prop="Solvency"
                                :label="$t('CreditOpinion.SolvencyIndexSI')"
                                align="left"
                                show-overflow-tooltip
                              >
                              </el-table-column>
                              <el-table-column
                                prop="Risk"
                                :label="$t('CreditOpinion.RiskIndicator')"
                                align="left"
                                show-overflow-tooltip
                              >
                              </el-table-column>
                            </el-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <div class="echarts" ref="riskRef"></div>
                <ul class="echarts-content">
                  <li
                    class="echarts-item"
                    style="align-items: center"
                    v-for="(item, index) in cardlist"
                    :key="index"
                  >
                    <div
                      class="echarts-item-left-new"
                      @click="scrollToTop('#Card')"
                    >
                      <span
                        style="font-family: 'Arial Bold'"
                        v-if="item.title == 'Local Credit Score:'"
                        >{{ $t("CreditOpinion.LocalCreditScore") }}</span
                      >
                      <span
                        style="font-family: 'Arial Bold'"
                        v-if="item.title == 'Solvency Index:'"
                        >{{ $t("CreditOpinion.SolvencyIndex") }}</span
                      >
                      <span
                        style="font-family: 'Arial Bold'"
                        v-if="item.title == 'Probability of Default:'"
                        >{{ $t("CreditOpinion.ProbabilityofDefault") }}</span
                      >
                      <span
                        style="font-family: 'Arial Bold'"
                        v-if="item.title == 'Risk Indicator:'"
                        >{{ $t("CreditOpinion.RiskIndicator") }}
                      </span>
                      <span
                        style="font-family: 'Arial Bold'"
                        v-if="item.title == 'Credit Line:'"
                        >{{ $t("CreditOpinion.CreditLine") }}
                      </span>
                    </div>
                    <span>{{ item.text  }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </gui_card>
      </div>

      <gui_card id="ge6845" v-else class="uc1096" label="" :isShowLabel="false">
        <div>
          <h2 class="operations-head-content">
            <span class="operations-head"
              >{{ $t("CreditOpinion.CreditAssessment") }}
            </span>
          </h2>

          <div class="flex_center">
            <img
              class="nodataImg"
              src="../../../../assets/images/noDate.png"
              alt=""
            />
          </div>
        </div>
      </gui_card>
      <gui_card
        v-if="parentTablelist.length > 0 && Related"
        id="ge6845"
        class="uc1096 mt10"
        label=""
        :isShowLabel="false"
      >
        <div id="Card">
          <h2 class="operations-head-content">
            <span class="operations-head">{{
              $t("CreditOpinion.RelatedCreditAssessment")
            }}</span>

            <svg
              @click="Related = false"
              t="1718863593010"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4791"
              width="1.85rem"
              height="1.85rem"
            >
              <path
                d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                fill="#333333"
                p-id="4792"
              ></path>
            </svg>
          </h2>

          <!-- 关联公司 -->
          <div class="computer_right_cont_box">
            <div
              class="infinite-list-wrapper"
              v-infinite-scroll="infiniteScroll"
              style="overflow: auto"
              :infinite-scroll-disabled="false"
              :infinite-scroll-distance="5"
            >
              <div class="ecahrts-header ecahrts-header-one">
                <span class="title-left">
                  <span
                    style="margin-right: 5px; width: 450px"
                    class="line_1 relate-left"
                    >{{ $t("Profile.CompanyName") }}</span
                  >
                </span>
                <span
                  class="relate-Financial"
                  style="font-family: 'Arial Bold'"
                  >{{ $t("CreditOpinion.CompanyID") }}</span
                >
                <span
                  class="relate-Financial"
                  style="font-family: 'Arial Bold'"
                  >{{ $t("CreditOpinion.Country") }}</span
                >
                <span
                  class="relate-Financial"
                  style="font-family: 'Arial Bold'"
                  >{{ $t("CreditOpinion.CompanyStatus") }}</span
                >
                <span
                  class="relate-Financial"
                  style="font-family: 'Arial Bold'"
                  >{{ $t("CreditOpinion.Relations") }}</span
                >

                <!-- <span style="
                      display: flex;
                      justify-content: flex-start;
                      width: 280px;
                    " class="line_1 relate-Financial"></span> -->
                <div class="head_loging"></div>
              </div>
              <!-- <div v-infinite-scroll="load" infinite-scroll-disabled="disabled"> -->
              <div
                class="footer"
                v-for="(item, index) in parentTablelist"
                :key="index"
                v-loading="item.loading2"
              >
                <div class="ecahrts-header">
                  <span class="title-left">
                    <span
                      style="
                        cursor: pointer;
                        margin-right: 5px;
                        width: 450px;
                        font-family: Arial;
                      "
                      class="line_1 relate-left"
                      @click="setid(item)"
                      >{{ item.nameEn }}</span
                    >
                  </span>
                  <span class="relate-Financial">{{ item.id }}</span>
                  <span class="relate-Financial">{{ item.country }}</span>
                  <span class="relate-Financial">{{ item.status }}</span>
                  <span class="line_1 relate-Financial">{{ item.typeEn }}</span>

                  <div class="head_loging">
                    <el-switch
                      active-color="#55B419"
                      :value="loginStatus1[index]"
                      @change="loginPop(index, item.aaaid, item.nameEn)"
                    ></el-switch>
                  </div>
                </div>
                <div
                  v-show="loginStatus1[index]"
                  class="ecahrtstu flex_between_box tableVuetwo"
                >
                  <div class="left_box">
                    <tableVue
                      :profitablitylist="item.profitablitylist1"
                      :yearslist="item.yearslist"
                      :dia="id3a"
                      :untia="untia"
                    ></tableVue>
                  </div>
                  <div class="right_box">
                    <div class="ecahrtstutwo">
                      <div class="table">
                        <div class="table_box_2">
                          <span class="aaa">{{
                            $t("CreditOpinion.HighRisk")
                          }}</span>
                          <span class="bbb">{{
                            $t("CreditOpinion.Medium")
                          }}</span>
                          <span class="ccc">{{
                            $t("CreditOpinion.Moderate")
                          }}</span>
                          <span class="ddd">{{
                            $t("CreditOpinion.Average")
                          }}</span>
                          <span class="fff">{{
                            $t("CreditOpinion.LowerThanAvg")
                          }}</span>
                          <span class="ggg">{{
                            $t("CreditOpinion.LowRisk")
                          }}</span>
                          <span class="hhh"
                            >{{ $t("CreditOpinion.CreditOpinion") }}
                          </span>
                          <div class="echarts" ref="chartRef"></div>
                          <ul class="echarts-content">
                            <li
                              class="echarts-item"
                              v-for="(item, index) in item.relatedcardlist"
                              :key="index"
                            >
                              <span
                                class="echarts-item-left"
                                v-if="item.title == 'Local Credit Score:'"
                                >{{
                                  $t("CreditOpinion.LocalCreditScore")
                                }}</span
                              >
                              <span
                                class="echarts-item-left"
                                v-if="item.title == 'Solvency Index:'"
                                >{{ $t("CreditOpinion.SolvencyIndex") }}</span
                              >
                              <span
                                class="echarts-item-left"
                                v-if="item.title == 'Probability of Default:'"
                                >{{
                                  $t("CreditOpinion.ProbabilityofDefault")
                                }}</span
                              >
                              <span
                                class="echarts-item-left"
                                v-if="item.title == 'Risk Indicator:'"
                                >{{ $t("CreditOpinion.RiskIndicator") }}</span
                              >
                              <span
                                class="echarts-item-left"
                                v-if="item.title == 'Credit Line:'"
                                >{{ $t("CreditOpinion.CreditLine") }}
                              </span>

                              <span>{{ item.text }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <tableVue
                    :profitablitylist="item.profitablitylist1"
                    :yearslist="item.yearslist"
                    :dia="id3a"
                    :untia="untia"
                  ></tableVue> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </gui_card>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import { getrelatedCompanylist, getCreditAssessment } from "@/api/companyApi";
import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import tableVue from "../CreditOpinion/table.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import { mixins1 } from "@/mixins/index";
//importEnd

export default {
  name: "",

  props: {},
  mixins: [mixins1],
  components: {
    gui_card,
    rectcard,
    content_text,
    tableVue,
    ReLogin,
  },
  computed: {},
  created() {},
  mounted() {
    this.getlist();
    this.getrelateList();
    this.riskEchart();
    this.$emit("UpdatamarkTotalList", []);
  },
  data() {
    return {
      reLoginVis: false,
      nodataYears1: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
      },
      Related: true,
      untia: "",
      yearslist1: [],
      createDialog: false,
      parentTablelist: [],
      loginStatus1: [],
      id3a: [],
      profitablitylist: [],
      RatingData: [
        {
          ARating: "3A1 - 3A5",
          External: "AAA - BBB",
          Default: "0.001% - 0.280%",
          Credit: "100 - 77",
          Solvency: "100 - 211",
          Risk: "Low Risk",
        },
        {
          ARating: "3A5 - 3A7",
          External: "BBB- - BB+",
          Default: "0.400% - 0.700%",
          Credit: "75 - 70",
          Solvency: "212 - 246",
          Risk: "Lower than Average Risk",
        },
        {
          ARating: "3A7 - 3A9",
          External: "BB - BB-",
          Default: "1.100% - 2.000%",
          Credit: "60 - 55",
          Solvency: "247 - 283",
          Risk: "Average Risk",
        },
        {
          ARating: "3A9 - 3A11",
          External: "B+ - B",
          Default: "3.000%",
          Credit: "50",
          Solvency: "284 - 300",
          Risk: "Moderate Risk",
        },
        {
          ARating: "3A11 - 3A16",
          External: "B- - CCC",
          Default: "4.700% - 8.100%",
          Credit: "40 - 30",
          Solvency: "301 - 345",
          Risk: "Medium Risk",
        },
        {
          ARating: "3A16 - 3A19",
          External: "CC - C",
          Default: "15.000% - 35.000%",
          Credit: "20 - 5",
          Solvency: "346 - 600",
          Risk: "High Risk",
        },
      ],
      profitablitylist1: [],
      companyList: [],
      noMore: false, // 控制滚动禁用
      routeLoad: false, // 控制滚动禁用
      icon: "",
      showBackToTop: false,
      newDialog: false,
      creditOpinion: "",
      creditScore: "",
      cardlist: [
        {
          title: "Local Credit Score:",
          text: "-",
        },

        {
          title: "Solvency Index:",
          text: "-",
        },
        {
          title: "Probability of Default:",
          text: "-",
        },
        {
          title: "Credit Line:",
          text: "-",
        },
        {
          title: "Risk Indicator:",
          text: "-",
        },
      ],

      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  methods: {
    scrollToTop(anchor) {
      if (this.parentTablelist.length > 0) {
        // this.Related = true;
      } else {
        this.getrelateList();
      }
      const el = document.querySelector(anchor);
      el.scrollIntoView({ behavior: "smooth" });
      this.Related = true;
    },
    createDialogcheck(value) {
      this.createDialog = value;
    },
    getlist() {
      const params = {
        id3a: this.$route.query.id3a,
      };
      getCreditAssessment(params)
        .then((res) => {
          this.loading = false;
          //  JSON.parse(crypto.decrypt(res))
          let data = res;
          if (data.code == 200) {
            this.loading = false;
            let { ca, creditBO, years, unit, nodataYears } = data.data;

            this.untia = unit;
            this.nodataYears1 = nodataYears;
            this.profitablitylist = ca;
            this.yearslist1 = years;
            this.cardlist.map((item, index) => {
              if (item.title == "Local Credit Score:") {
                item.text = creditBO.creditScore;
                item.label =
                  "Credit scores are calculated on a scale from 1 to 100, based on the credit rating obtained from local authorities. A higher score indicates better creditworthiness.";
              }
              if (item.title == "Probability of Default:") {
                item.text = creditBO.pd;
                item.label =
                  "The Possibility of Default (PD) is a useful tool for risk assessment, focusing on short-term liquidity evaluation.";
              }
              if (item.title == "Solvency Index:") {
                item.text = creditBO.si;
                item.label =
                  "The Solvency Index (SI) is a highly effective and reliable early warning indicator that allows for a rapid assessment of the solvency of business partners. A higher SI value indicates a higher risk of default by a client. The SI ranges from 100, which is considered an excellent rating, to 600, where highly negative characteristics are present.";
              }
              if (item.title == "Credit Line:") {
                item.text = creditBO.creditLine;
              }
              if (item.title == "Risk Indicator:") {
                item.text = creditBO.riskIndicator;
                item.label = "-";
              }
            });
            this.creditOpinion = creditBO?.creditOpinion;
            this.creditScore = Number(creditBO?.creditScore) / 100;
          } else {
            this.loading = false;
            this.creditOpinion = "unrated";
            this.creditScore = 0;
          }
          this.$nextTick(() => {
            this.riskEchart();
          });
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    infiniteScroll() {
      this.routeLoad = false;
    },
    getrelateList() {
      getrelatedCompanylist({
        id3a: this.$route.query.id3a,
        type: 1,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        resourceType: 1,
      }).then((res) => {
        if (res.code == 200) {
          this.parentTablelist = res.data.rows;
          this.routeLoad = false;
          // this.parentTablelist = res.data.rows;

          this.parentTablelist.map((item) => {
            item.profitablitylist1 = [];
            item.loading2 = false;
            item.yearslist = [];
            item.chartInstance = null;
            item.relatedcardlist = [
              {
                title: "Local Credit Score:",
                text: "-",
              },

              {
                title: "Solvency Index:",
                text: "-",
              },
              {
                title: "Probability of Default:",
                text: "-",
              },
              {
                title: "Credit Line:",
                text: "-",
              },
              {
                title: "Risk Indicator:",
                text: "-",
              },
            ];
          });
        }
      });
    },
    async loginPop(index, id, nameEn) {
      this.indexclose = index;
      this.$set(this.loginStatus1, index, !this.loginStatus1[index]);
      if (this.loginStatus1[index]) {
        //   this.loading1=true
        this.parentTablelist[index].loading2 = true;
        const params = {
          id3a: id,
        };

        if (true) {
          this.getparamslist(params, index);
        }
      }
    },
    // 获取数据
    getparamslist(params, index) {
      getCreditAssessment(params).then((res) => {
        this.parentTablelist[index].loading2 = false;
        let data = res;

        let { ca, creditBO, years, unit } = data.data;
        this.parentTablelist[index].yearslist = years;
        this.id3a = years;
        this.parentTablelist[index].profitablitylist1 = ca;
        this.untia = unit;
        let that = this;
        that.loginStatus1[index] = true;
        this.parentTablelist[index].relatedcardlist.map((item, index) => {
          if (item.title == "Local Credit Score:") {
            item.text = creditBO.creditScore;
          }
          if (item.title == "Probability of Default:") {
            item.text = creditBO.pd;
          }
          if (item.title == "Solvency Index:") {
            item.text = creditBO.si;
          }
          if (item.title == "Credit Line:") {
            item.text = creditBO.creditLine;
          }
          if (item.title == "Risk Indicator:") {
            item.text = creditBO.riskIndicator;
          }
        });

        this.creditOpinion = creditBO?.creditOpinion;
        this.creditScore = Number(creditBO?.creditScore) / 100;
        // const chartDom = this.$refs.chartRef[index];
        // const chart = this.$echarts.getInstanceByDom(chartDom) || this.$echarts.init(chartDom);
        const option = {
          grid: {
            left: "0",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          //
          series: [
            {
              type: "gauge",
              startAngle: 180,
              endAngle: 0,

              center: ["50%", "75%"],
              radius: "146%",
              // radius: '145%',
              clockwise: true,
              show: true,
              min: 0,
              max: 1,
              splitNumber: 5,

              axisLine: {
                roundCap: true,
                lineStyle: {
                  width: 20,

                  color: [
                    [
                      0.25,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 1,
                            color: "#F56B6BFF",
                          },
                        ],

                        global: false,
                      },
                    ],

                    [
                      0.5,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 0,
                            color: "#FFDC17FF",
                          },
                          {
                            offset: 1,
                            color: "#FA6666FF",
                          },
                        ],

                        global: false,
                      },
                    ],

                    [
                      1,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 0,
                            color: "#FFDC17FF",
                          },
                          {
                            offset: 1,
                            color: "#55B419FF",
                          },
                        ],

                        global: false,
                      },
                    ],
                  ],
                },
              },

              pointer: {
                icon: "circle",

                length: "20%",
                width: 22,
                offsetCenter: [0, "-85%"],
                itemStyle: {
                  color: "auto",
                },
              },
              axisTick: {
                length: 5,
                distance: -28,
                lineStyle: {
                  color: "auto",
                  width: 2,
                },
              },
              // 刻度线
              splitLine: {
                show: false,
                length: 10,
                // distance:-20,
                lineStyle: {
                  color: "auto",
                  width: 8,
                },
              },
              axisLabel: {
                show: false,
                rotate: "tangential",
                fontWeight: "normal",
                fontSize: 0,
                distance: -62,
                width: 70,
                height: 40,
                fontFamily: "Arial",
                overflow: "truncate",
                color: [
                  [
                    0.25,
                    {
                      type: "linear",

                      x: 0,

                      y: 10,

                      x2: 30,

                      y2: 11,

                      colorStops: [
                        {
                          offset: 1,
                          color: "#F56B6BFF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],

                formatter: function (value) {
                  if (value === 1) {
                    return "Low Risk";
                  } else if (value === 0.8) {
                    return "Lower Than Avg.";
                  } else if (value === 0.6) {
                    return "Average";
                  } else if (value === 0.4) {
                    return "Moderate";
                  } else if (value === 0.2) {
                    return "Medium";
                  } else if (value === 0.0) {
                    return "High Risk";
                  }
                  return "";
                },
              },

              title: {
                offsetCenter: [0, "20%"],
                fontSize: 15,
                color: "#ccc",
              },
              // 仪表盘数字
              detail: {
                lineHeight: 126,
                fontSize: 35,
                offsetCenter: [1, "-22"],
                valueAnimation: true,

                borderColor: "#55B419FF",

                width: 200,
                formatter: function (value) {
                  var a = "d";
                  if (Math.round(value * 100)) {
                    a = "A";
                  }
                  return that.creditOpinion;
                },
                color: "#55B419FF",
              },
              data: [
                {
                  value: that.creditScore,
                  // name: "Credit Opinion",
                },
              ],
            },
            {
              type: "gauge",
              startAngle: 180,
              endAngle: 0,
              center: ["50%", "75%"],
              radius: "96%",
              min: 0,
              max: 1,

              axisTick: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  width: 1,
                  color: [
                    [
                      0.5,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 0,
                            color: "#FFDC17FF",
                          },
                          {
                            offset: 1,
                            color: "#FA6666FF",
                          },
                        ],

                        global: false,
                      },
                    ],

                    [
                      1,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 0,
                            color: "#FFDC17FF",
                          },
                          {
                            offset: 1,
                            color: "#55B419FF",
                          },
                        ],

                        global: false,
                      },
                    ],
                  ],
                },
              },
              pointer: {
                icon: "triangle",
                length: "12%",
                width: 20,
                offsetCenter: [0, "-105%"],
                itemStyle: {
                  color: "#55B419FF",
                },
              },

              data: [
                {
                  value: that.creditScore,
                  detail: {
                    show: false,
                  },
                },
              ],
            },
          ],
        };

        const chartDom = this.$refs.chartRef[index];
        const chart =
          this.$echarts.getInstanceByDom(chartDom) ||
          this.$echarts.init(chartDom);
        chart.setOption(option);
        this.parentTablelist[index].chartInstance = chart;
      });
    },

    riskEchart() {
      const that = this;
      const option = {
        grid: {
          left: "0",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        //
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,

            center: ["50%", "75%"],
            radius: "146%",
            // radius: '145%',
            clockwise: true,
            show: true,
            min: 0,
            max: 1,
            splitNumber: 5,

            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 20,

                color: [
                  [
                    0.25,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 1,
                          color: "#F56B6BFF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },

            pointer: {
              icon: "circle",

              length: "20%",
              width: 22,
              offsetCenter: [0, "-85%"],
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              length: 5,
              distance: -28,
              lineStyle: {
                color: "auto",
                width: 2,
              },
            },
            // 刻度线
            splitLine: {
              show: false,
              length: 10,
              // distance:-20,
              lineStyle: {
                color: "auto",
                width: 8,
              },
            },
            axisLabel: {
              show: false,
              rotate: "tangential",
              fontWeight: "normal",
              fontSize: 0,
              distance: -62,
              width: 70,
              height: 40,
              fontFamily: "Arial",
              overflow: "truncate",
              color: [
                [
                  0.25,
                  {
                    type: "linear",

                    x: 0,

                    y: 10,

                    x2: 30,

                    y2: 11,

                    colorStops: [
                      {
                        offset: 1,
                        color: "#F56B6BFF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  0.5,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#FA6666FF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  1,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#55B419FF",
                      },
                    ],

                    global: false,
                  },
                ],
              ],

              formatter: function (value) {
                if (value === 1) {
                  return "Low Risk";
                } else if (value === 0.8) {
                  return "Lower Than Avg.";
                } else if (value === 0.6) {
                  return "Average";
                } else if (value === 0.4) {
                  return "Moderate";
                } else if (value === 0.2) {
                  return "Medium";
                } else if (value === 0.0) {
                  return "High Risk";
                }
                return "";
              },
            },

            title: {
              offsetCenter: [0, "20%"],
              fontSize: 15,
              color: "#ccc",
            },
            // 仪表盘数字
            detail: {
              lineHeight: 126,
              fontSize: 35,
              offsetCenter: [1, "-22"],
              valueAnimation: true,

              borderColor: "#55B419FF",

              width: 200,
              formatter: function (value) {
                var a = "d";
                if (Math.round(value * 100)) {
                  a = "A";
                }
                return that.creditOpinion;
              },
              color: "#55B419FF",
            },
            data: [
              {
                value: that.creditScore,
                // name: "Credit Opinion",
              },
            ],
          },
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", "75%"],
            radius: "96%",
            min: 0,
            max: 1,

            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 1,
                color: [
                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },
            pointer: {
              icon: "triangle",
              length: "12%",
              width: 20,
              offsetCenter: [0, "-105%"],
              itemStyle: {
                color: "#55B419FF",
              },
            },

            data: [
              {
                value: that.creditScore,
                detail: {
                  show: false,
                },
              },
            ],
          },
        ],
      };
      this.riskChart = this.$echarts.init(this.$refs.riskRef);
      this.riskChart.setOption(option);
    },
    // insertMethod
    // srcviewscompanydetailsBackgroundSnapshotvueMethodStart
    // default
    default() {},
    // srcviewscompanydetailsBackgroundSnapshotvueMethodEnd
  },
};
</script>
<style scoped>
.operations-head {
  color: #1290c9;
}
.uPdtqFl {
  padding-right: 2.857142857142857rem;
  padding-top: 2.142857142857143rem;
  padding-left: 2.857142857142857rem;
  padding-bottom: 2.142857142857143rem;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 0.2857142857142857rem;
  border-bottom-left-radius: 0.2857142857142857rem;
  border-top-right-radius: 0.2857142857142857rem;
  border-bottom-right-radius: 0.2857142857142857rem;
}

.importDetail-head {
  display: flex;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contclass {
  font-size: 1.285714285714286rem;
  color: #238acc;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

.ViewMore {
  line-height: 32px;
  text-align: left;
  font-style: normal;
  font-size: 20px;
}
.ViewMore span {
  text-decoration-line: underline;
}

.uc1096 {
  height: 100%;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-left {
  display: flex;
  font-size: 18px;
  font-family: "Arial Bold";
  font-weight: normal;
  color: #022955;
  padding-left: 1.4285714285714286rem;
  display: flex;
  align-items: center;
  padding-bottom: 11px;
  padding-top: 11px;
  /* background-color: #f2f5f9; */
}
.title-left .relate-left {
  font-family: "Arial Bold";
}

.footer {
  padding-left: 0rem;
  overflow: hidden;
}

.ecahrts-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.07142857142857142rem solid #cccccc;
}

.td {
  margin: 1.0714285714285714rem 0 0 1.7857142857142858rem;
}

.relate-left {
  height: 58px;
  font-size: 18px;
  color: #1a2332;
  /* line-height: 4rem; */
  text-align: left;
  display: flex;
  align-items: center;
  white-space: normal !important;
  word-break: keep-all;
  /* font-family: 'Arial Bold'; */
}

.relate-Financial {
  font-size: 18px;
  color: #1a2332;
  width: 15%;
}
.ecahrts-header-one .relate-Financial,
.ecahrts-header-one {
  font-size: 18px;
}

.tablewieth {
  width: 70%;
}

.aaa {
  font-size: 14px;
  color: #fa6666;
  position: absolute;
  left: 30px;
  top: 210px;
}

.bbb {
  font-size: 14px;
  color: #fa755c;
  position: absolute;
  left: 30px;
  top: 100px;
}

.ccc {
  font-size: 14px;
  color: #fc9249;
  position: absolute;
  left: 100px;
  top: 10px;
}

.ddd {
  font-size: 14px;
  color: #ffd81a;
  position: absolute;
  left: 360px;
  top: 10px;
}

.fff {
  font-size: 14px;
  color: #aec918;
  position: absolute;
  width: 45px;
  height: 80px;
  top: 90px;
  left: 450px;
}

.ggg {
  font-size: 14px;
  color: #63b819;
  position: absolute;
  left: 430px;
  top: 210px;
}

.hhh {
  font-size: 20px;
  color: #1a2332;
  position: absolute;
  left: 190px;
  top: 220px;
  z-index: 9999999;
}

.echarts {
  width: 520px;
  height: 260px;
  padding-left: 20px;
  padding-right: 20px;
}

.table_box {
  position: relative;
  margin-top: 6.428571428571429rem;
  margin-bottom: 6.7rem;
}
.table_box_2 {
  position: relative;
  margin-top: 6.428571428571429rem;
  margin-bottom: 6.7rem;
}

.echarts-content {
  margin-top: 30px;
  padding: 0 20px;
}

.echarts-item {
  display: flex;
  justify-content: flex-start;
  font-size: 20px;
  color: #1a2332;
  line-height: 20px;
  margin-bottom: 30px;
}

.echarts-item-left {
  width: 15.714285714285714rem;
  margin-right: 1.4285714285714286rem;
  font-family: "Arial Bold";
}
.echarts-item-left-new {
  display: flex;
  align-items: center;
  width: 17.714285714285714rem;
  margin-right: 1.4285714285714286rem;
}
.ecahrtstutwo {
  position: relative;
  /* left: 1.4285714285714286rem; */
}

.uUIRzUi {
  padding: 30px 40px;
}
.left_box {
  width: calc(100% - 520px);
  background-color: #fff;
}
.right_box {
  width: 520px;
  height: 684px;
  background-color: #fff;
  padding: 0px;
}
.ecahrts-header-one {
  background-color: #f2f5f9;
  height: 3.57142857rem;
  /* line-height: 3.57142857rem; */
}
.Financial-icon-box {
  display: none;
  width: 500px;
  max-height: 300px;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  position: absolute;

  left: -470px;
  top: 30px;
  z-index: 99999999;
  padding: 1.42857143rem;
  color: #29445d;
  font-size: 1.285714rem;
}
.Financial-icon-part {
  position: relative;
  /* left: 5px; */
}
.Financial-icon-part:hover .Financial-icon-box {
  display: block;
}
.Financial-icon-boxCredint {
  /* display: block; */
  width: 500px;
  top: 100%;
}
.Financial-icon-part-right {
  position: absolute;
  /* right: 20px;
  top: -55px; */
  right: -25px;
  top: -3px;
}

.Financial-icon-bocredit {
  /* display: block; */
  width: 975px;
  top: 0px;
  left: -970px;
}
.Financial-icon-bocredit-title {
  font-size: 20px;
  color: #1a2332;
  font-family: "Arial Bold";
}

.huanggantanhaoicon {
  font-size: 24px;
  margin-left: 8px;
  color: #ffc800;
}
.riliicon {
  font-size: 32px;
  margin-left: 40px;
  color: #1290c9;
}
.cuowuicon {
  font-size: 30px;
}

.content-left {
  width: calc(100% - 530px);
  margin-right: 10px;
}
.content-right {
  width: 520px;
  height: 684px;
}
@media screen and (max-width: 1920px) {
  .uUIRzUi {
    padding: 22px 30px;
  }

  .huanggantanhaoicon {
    font-size: 18px;
    margin-left: 6px;
  }
  .riliicon {
    font-size: 24px;
    margin-left: 30px;
  }
  .cuowuicon {
    font-size: 22px;
  }
  .ViewMore {
    line-height: 24px;
    font-size: 16px;
  }
  .title-left {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .relate-left {
    height: 44px;
    font-size: 16px;
    line-height: 20px;
  }
  .relate-Financial {
    font-size: 16px;
  }
  .ecahrts-header-one .relate-Financial,
  .ecahrts-header-one {
    font-size: 16px;
  }
  .Financial-icon-box {
    font-size: 14px;
  }
  .content-left {
    width: calc(100% - 400px);
    height: 513px !important;
  }
  .content-right {
    width: 390px;
    height: 513px;
  }
  .left_box {
    width: calc(100% - 390px);
  }
  .right_box {
    width: 390px;
    height: 460px;
  }

  .aaa {
    font-size: 14px;
    left: 20px;
    top: 160px;
  }

  .bbb {
    font-size: 14px;
    left: 15px;
    top: 50px;
  }

  .ccc {
    font-size: 14px;
    left: 60px;
    top: 0px;
  }

  .ddd {
    font-size: 14px;
    left: 270px;
    top: 0px;
  }

  .fff {
    font-size: 14px;
    width: 45px;
    height: 80px;
    top: 50px;
    left: 340px;
  }

  .ggg {
    font-size: 14px;
    left: 310px;
    top: 160px;
  }

  .hhh {
    font-size: 16px;
    left: 140px;
    top: 160px;
  }

  .echarts {
    width: 390px;
    height: 195px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .echarts-item {
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 22px;
  }
  .Financial-icon-bocredit {
    width: 900px;
    top: 30px;
    left: -870px;
  }
  .Financial-icon-bocredit-title {
    font-size: 14px;
  }
  .table_box {
    position: relative;
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .table_box_2 {
    position: relative;
    margin-top: 30px;
    margin-bottom: 20px;
  }
}

@media (max-width: 1439px) {
  .uUIRzUi {
    padding: 20px 26px;
  }

  .huanggantanhaoicon {
    font-size: 16px;
    margin-left: 5px;
  }
  .riliicon {
    font-size: 22px;
    margin-left: 26px;
  }
  .cuowuicon {
    font-size: 20px;
  }
  .ViewMore {
    line-height: 22px;
    font-size: 14px;
  }
  .title-left {
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .relate-left {
    height: 40px;
    font-size: 12px;
  }

  .ecahrts-header-one .relate-Financial,
  .ecahrts-header-one {
    font-size: 14px;
  }
  .Financial-icon-box {
    font-size: 12px;
  }
  .content-left {
    width: calc(100% - 360px);
  }
  .content-right {
    width: 350px;
    height: 462px;
  }
  .left_box {
    width: calc(100% - 350px);
  }
  .right_box {
    width: 350px;
    height: 462px;
  }

  .aaa {
    font-size: 14px;
    left: 10px;
    top: 140px;
  }

  .bbb {
    font-size: 14px;
    left: 15px;
    top: 50px;
  }

  .ccc {
    font-size: 14px;
    left: 50px;
    top: 0px;
  }

  .ddd {
    font-size: 14px;
    left: 250px;
    top: 0px;
  }

  .fff {
    font-size: 14px;
    width: 45px;
    height: 80px;
    top: 30px;
    left: 300px;
  }

  .ggg {
    font-size: 14px;
    left: 280px;
    top: 140px;
  }

  .hhh {
    font-size: 14px;
    left: 120px;
    top: 140px;
  }
  .echarts {
    width: 350px;
    height: 175px;
    padding-left: 12px;
    padding-right: 12px;
  }
  .echarts-item {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 20px;
  }
  .Financial-icon-bocredit {
    width: 650px;
    top: 0px;
    left: -650px;
  }
  .Financial-icon-bocredit-title {
    font-size: 12px;
  }
}
</style>
